import router from "../router";

export function goBack() {
  router.go(-1);
}
